import React, { memo } from 'react';
import { RecordUsageRes } from '../../../redux/recordUsage/recordUsageApiSlice';
import { displayInfo } from '../EcwConstants';

interface BarcodeInfoProps {
    barcodeInfo: RecordUsageRes | null;
}

const BarcodeInfo: React.FC<BarcodeInfoProps> = ({ barcodeInfo }) => {
    if (!barcodeInfo) return null;

    return (
        <div className='barcode-info-box'>
            <h5 className="box-title">Item Details</h5>
            <div className="barcode-info-container">
                <h5 className="barcode-title">{displayInfo(barcodeInfo.rxName)}</h5>
                <div>
                    <span>Item Group</span>
                    <p>{displayInfo(barcodeInfo.rxCategory)}</p>
                </div>
                <div>
                    <span>Manufacturer</span>
                    <p>{displayInfo(barcodeInfo.manufacturer)}</p>
                </div>
                <div>
                    <span>Item Type</span>
                    <p>{displayInfo(barcodeInfo.list1)}</p>
                </div>
                <div>
                    <span>Stock</span>
                    <p>{displayInfo(barcodeInfo.list2)}</p>
                </div>
                <div>
                    <span>NDC/SKU</span>
                    <p>{displayInfo(barcodeInfo.ndc)}</p>
                </div>
                <div>
                    <span>NDC11</span>
                    <p>{displayInfo(barcodeInfo.ndC11)}</p>
                </div>
                <div>
                    <span>LOT Number</span>
                    <p>{displayInfo(barcodeInfo.lotNo)}</p>
                </div>
                <div>
                    <span>Expiration Date</span>
                    <p>{displayInfo(barcodeInfo.expDate)}</p>
                </div>
                <div>
                    <span>CVX/Model</span>
                    <p>{displayInfo(barcodeInfo.cvx)}</p>
                </div>
                <div>
                    <span>MVX Code</span>
                    <p>{displayInfo(barcodeInfo.mvxCode)}</p>
                </div>
                <div>
                    <span>MVX Manufacturer</span>
                    <p>{displayInfo(barcodeInfo.mvxManufacturer)}</p>
                </div>
            </div>
        </div>
    );
};

export default memo(BarcodeInfo);